module.exports = __webpack_public_path__ + "5084e208ed97a75139c13fdd686ed25f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/SadBaggageClaim.jpg
// module id = 2034
// module chunks = 1